import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Avatar, Row, Col, DatePicker } from 'antd';
import { Link } from 'react-router-dom';
import moment from "moment";
import Tab from '../Tab';
import Layout from '../Layout';
import IsApproved from '../../components/IsApproved';
import ErrorAlert from '../../components/ErrorAlert';
import { get, remove, resetState } from '../../modules/places';
import { getFormattedAddress } from "../../utils/getFormatedAddress";

const { RangePicker } = DatePicker

class PlacesTab extends Tab {
  columns = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: 'id',
      sorter: true,
    }, {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
      render: (name, data) => {
        return (
          <Fragment>
            <Avatar
              size="large"
              src={data.logo}
              className="mr-1"
            />
            <Link to={`places/${data.id}`}>{name}</Link>
          </Fragment>
        );
      },
    }, {
      key: 'address',
      title: 'Address',
      dataIndex: 'address',
      render: (name, data) => {
        const { main, secondary } = getFormattedAddress(data.address);
        return (
          <Fragment>
            <div>{main}</div>
            <span className={'color-grey'}><i>{secondary}</i></span>
          </Fragment>
        )
      },
    }, {
      key: 'approved',
      title: 'Approved',
      dataIndex: 'approved',
      render: (name, data) => <IsApproved isApproved={data.approved}/>,
    }, {
      key: 'created_at_range',
      title: 'Created At',
      dataIndex: 'created_at',
      render: (created_at) => <span>{created_at ? moment(created_at).format('DD MMM Y, hh:mm A') : ''}</span>,
      sorter: true,
      filterDropdown: (props) => {
        const {
          setSelectedKeys, //: (selectedKeys: string[]) => void;
          selectedKeys, // ?: React.Key[];
          confirm, // : () => void;
          // clearFilters, // ?: () => void;
          // filters, // ?: ColumnFilterItem[];
          // getPopupContainer, // ?: (triggerNode: HTMLElement) => HTMLElement;
          // visible, // ?: boolean;
        } = props;

        const defaultValue = Array.isArray(selectedKeys) && selectedKeys.length === 2
          ? selectedKeys.map(d => moment(d))
          : undefined

        return (
          <RangePicker
            defaultValue={defaultValue}
            ranges={{
              Today: [moment().startOf('day'), moment().endOf('day')],
              Yesterday: [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
              'This Week': [moment().startOf('week'), moment().endOf('week')],
              'This Month': [moment().startOf('month'), moment().endOf('month')],
              'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
            }}
            onChange={(range) => {
              range.length
                ? setSelectedKeys([range[0].format(), range[1].format()])
                : setSelectedKeys([]);
              confirm();
            }}
          />
        );
      }
    },
    this.tableActions(),
  ];

  onParamsParseDone(state) {
    this.parseQuerySort(state, this.columns, 0, 'key');
    this.parseQuerySort(state, this.columns, 1, 'key');
    this.parseQuerySort(state, this.columns, 4);

    const createdAtFilter = state.filter && state.filter.created_at_range;
    if (createdAtFilter) {
      this.columns[4].defaultFilteredValue = createdAtFilter;
    }
  }

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error}/>
        <Row>
          <Col>
            {this.renderFiltersBlock(this.renderSearchInput('search', 'search'))}
          </Col>
        </Row>
        <Row>
          <Col>
            {this.renderDataTable()}
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.places,
  }),
  {
    get, remove, resetState,
  })(PlacesTab);




// WEBPACK FOOTER //
// ./src/containers/Places/PlacesTab.js